import {
  convertLabelMapToConfig,
  convertLabelUomMapToConfig,
  mergeConfig,
} from 'Components/Worksheets/Core/Helpers/configHelpers';

const getLabelConfig = (prefix: string) =>
  mergeConfig(
    convertLabelMapToConfig({
      [`${prefix}.Preparation.LightweightAggregate`]: 'Lightweight Aggregate',
      [`${prefix}.Preparation.VisualNominalParticleSize`]: 'Nominal Diameter',

      [`${prefix}.Equipment.DryingTemperature`]: 'Drying Temperature',
      [`${prefix}.Equipment.Balance`]: 'Balance',
      [`${prefix}.Equipment.Oven`]: 'Oven',
      [`${prefix}.Equipment.DryMassBalance`]: 'Dry Mass Balance',

      [`${prefix}.Measurements.VolumeDeterminationMethod`]: 'Volume Determined By',
      [`${prefix}.Measurements.BulkDensity`]: 'Bulk Density',
      [`${prefix}.Measurements.Volume`]: 'Volume',

      [`${prefix}.DryingTray.ContainerLabel`]: 'Tare ID',
      [`${prefix}.DryingTray.ContainerMass`]: 'Tare Mass',
      [`${prefix}.DryingTray.WetSoilAndContainerMass`]: 'Tare and Material Wet Mass',
      [`${prefix}.DryingTray.WetSoilMass`]: 'Material Wet Mass',
      [`${prefix}.DryingTray.DateTimePlacedInOvenLocal`]: `Date and Time in Oven`,
      [`${prefix}.DryingTray.ConstantDrySoilMass`]: 'Material Dry Mass',

      [`${prefix}.DryingTray.DryMassReadings.DryingTime`]: `Drying Time`,
      [`${prefix}.DryingTray.DryMassReadings.TareAndDryMass`]: `Tare and Material Dry Mass`,

      [`${prefix}.DryingTrays.ContainerLabel`]: 'Tare ID',
      [`${prefix}.DryingTrays.ContainerMass`]: 'Tare Mass',
      [`${prefix}.DryingTrays.WetSoilAndContainerMass`]: 'Tare and Material Wet Mass',
      [`${prefix}.DryingTrays.WetSoilMass`]: 'Material Wet Mass',
      [`${prefix}.DryingTrays.DateTimePlacedInOvenLocal`]: `Date and Time in Oven`,
      [`${prefix}.DryingTrays.ConstantDrySoilMass`]: 'Material Dry Mass',

      [`${prefix}.DryingTrays.DryMassReadings.DryingTime`]: `Drying Time`,
      [`${prefix}.DryingTrays.DryMassReadings.TareAndDryMass`]: `Tare and Material Dry Mass`,

      [`${prefix}.Results.ReportMass`]: `Dried Portion Mass`,
    }),
    convertLabelUomMapToConfig({
      [`${prefix}.Preparation.VisualNominalParticleSize`]: 'mm',
    })
  );

export default getLabelConfig;
